import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useClipsStore } from "./ClipsStore/clipsStore";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import { TableHeadComponentSmallerText } from "../../common/TableHead";

export const AlertsTableSMTP = () => {
  const { selectedRowAlertsSMTP } = useClipsStore();

  return (
    <Paper sx={{ width: 450, overflow: "hidden" }}>
      <TableContainer>
        <Table
          sx={{
            "& .MuiTableCell-root": {
              padding: "4px 16px",
            },
          }}
        >
          <TableHeadComponentSmallerText titlesArray={["Alert", ""]} />
          <TableBody>
            {selectedRowAlertsSMTP.length === 0 ? (
              <TableRow>
                <TableCell colSpan={2} align="center">
                  No Alerts for selected clip
                </TableCell>
              </TableRow>
            ) : (
              selectedRowAlertsSMTP.map((alert) => (
                <TableRow key={alert.custcam_id}>
                  <TableCell sx={{ textTransform: "capitalize" }}>
                    {alert.label}
                  </TableCell>
                  <TableCell align="center">
                    <OrangeTextButton
                      text="See Alert"
                      onClick={() => {
                        if (alert.url) {
                          window.open(
                            alert.url,
                            "_blank",
                            "noopener,noreferrer"
                          );
                        }
                      }}
                      disabled={!alert.url}
                    />
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};
